import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminBlackouts,
  initializeRateAdminBlackoutsScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminBlackouts,
  saveBlackoutsTableState,
  deleteRateAdminBlackouts,
} from "../../../redux/actions/RateAdmin/rateadminBlackouts";
import RateAdminBlackouts from '../../../component/RateAdmin/RateAdminBlackouts';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
function RateAdminBlackoutsScreen(props) {
  const {
    fetchRateAdminBlackouts,
    initRateAdminBlackoutsScreen,
    showPageLevelLoader,
    rateAdminBlackoutsListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminBlackouts,
    isRateAdminBlackoutsExportError,
    isRateAdminBlackoutsExportSuccess,
    isRateAdminBlackoutsDeleteSuccess,
    isRateAdminBlackoutsDeleteError,
    deleteRateAdminBlackouts,
    isLoading,
    savedTableState,
    saveBlackoutsTableState,
    shouldOpenDeleteConfirmationPopup,
    setDeleteConfirmationPopupVisibility,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId")
    };
  };

  useEffect(() => {
    initRateAdminBlackoutsScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRateAdminBlackouts(savedParams);
    } else {
      fetchRateAdminBlackouts({ sortField: 'id', userId: localStorage.getItem("userId") });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newPyload = {
      ...props,
      userId: localStorage.getItem("userId")
    }
    fetchRateAdminBlackouts(newPyload);
  };

  const handleTableStateChange = (tableState) => {
    saveBlackoutsTableState(tableState);
  };

  const handleCreateRateAdminBlackouts = () => {
    navigate(APP_URLS.RATEADMIN_BLACKOUTS.CREATE);
  }
  const editRateAdminBlackoutsRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_BLACKOUTS.EDIT, {
      id,
    });
    navigate(path);
  };
  const rateAdminBlackouts = {
    handleCreateRateAdminBlackouts,
    exportRateAdminBlackouts,
    isRateAdminBlackoutsExportError,
    isRateAdminBlackoutsExportSuccess,
    editRateAdminBlackoutsRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    fetchRateAdminBlackoutss: loadLazyData,
    tableData: {
      columns: rateAdminBlackoutsListview?.columns,
      rows: rateAdminBlackoutsListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    deleteRateAdminBlackouts,
    isRateAdminBlackoutsDeleteSuccess,
    isRateAdminBlackoutsDeleteError,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RateAdminBlackouts
        {...rateAdminBlackouts}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminBlackoutsScreen: () => dispatch(initializeRateAdminBlackoutsScreen()),
    fetchRateAdminBlackouts: (payload) => dispatch(fetchRateAdminBlackouts(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRateAdminBlackouts: (payload) => dispatch(exportRateAdminBlackouts(payload)),
    saveBlackoutsTableState: (payload) => dispatch(saveBlackoutsTableState(payload)),
    deleteRateAdminBlackouts: (payload) => dispatch(deleteRateAdminBlackouts(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRateAdminBlackoutsCreateSuccess: selectFromRateAdminBlackoutsReducer(
      state,
      "isRateAdminBlackoutsCreateSuccess"
    ),
    rateAdminBlackoutsListview: selectFromRateAdminBlackoutsReducer(
      state,
      "rateAdminBlackoutsListview"
    ),
    showPageLevelLoader: selectFromRateAdminBlackoutsReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminBlackoutsReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromRateAdminBlackoutsReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminBlackoutsReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminBlackoutsExportError: selectFromRateAdminBlackoutsReducer(
      state,
      "isRateAdminBlackoutsExportError"
    ),
    isRateAdminBlackoutsExportSuccess: selectFromRateAdminBlackoutsReducer(
      state,
      "isRateAdminBlackoutsExportSuccess"
    ),
    isRateAdminBlackoutsDeleteSuccess: selectFromRateAdminBlackoutsReducer(
      state,
      "isRateAdminBlackoutsDeleteSuccess"
    ),
    isRateAdminBlackoutsDeleteError: selectFromRateAdminBlackoutsReducer(
      state,
      "isRateAdminBlackoutsDeleteError"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromRateAdminBlackoutsReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),
    savedTableState: selectFromRateAdminBlackoutsReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminBlackoutsReducer = (state, path) => {
  return selectRateAdminBlackoutsReducer(state)[path];
};

const selectRateAdminBlackoutsReducer = ({ rateadminBlackoutsReducer }) => {
  return rateadminBlackoutsReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(RateAdminBlackoutsScreen);
